import { DateTime } from 'luxon'
import startCase from 'lodash/startCase'
import { toHoursAndMinutes } from '@/helpers/utils'

export default {
  methods: {
    formatAsDecimal(value, fractionDigits = 2) {
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(value)
    },

    formatAsNumber(value) {
      return new Intl.NumberFormat('de-DE').format(value)
    },

    formatAsPercent(value) {
      return new Intl.NumberFormat('de-DE', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
    },

    formatAsDate(value, format = 'iso') {
      if (format === 'sql') {
        DateTime.fromSQL(value).toFormat('dd.MM.yyyy')
      }

      return DateTime.fromISO(value).toFormat('dd.MM.yyyy')
    },

    formatAsDateTime(value, format = null, outputFormat = 'dd.MM.yyyy HH:mm:ss') {
      if (format === null) {
        return DateTime.fromISO(value).toFormat(outputFormat)
      }

      if (format === 'sql') {
        return DateTime.fromSQL(value).toFormat(outputFormat)
      }

      return DateTime.fromFormat(value, format).toFormat(outputFormat)
    },

    formatAsTime(value) {
      return DateTime.fromISO(value).toFormat('HH:mm:ss')
    },

    formatAsCurrency(value, locales = 'de-DE', options = {}) {
      return new Intl.NumberFormat(locales, {
        currency: 'EUR',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        ...options,
        style: 'currency'
      }).format(value)
    },

    formatAsTitleCase(value) {
      return startCase(`${value}`.toLowerCase())
    },

    formatAsHoursAndMinutes(minutes) {
      return toHoursAndMinutes(minutes)
    }
  }
}
